/* eslint-disable ember/no-computed-properties-in-native-classes */
import { computed } from '@ember/object';

import * as ReverseImplementation from './reverse-implementation';
import BigHugeCircuit from './big-huge-circuit';
import BaseBigHugeCircuitGroup from '../../implementation-common/base-big-huge-circuit-group';

export default class FirstOrderCommonBigHugeCircuitGroup extends BaseBigHugeCircuitGroup {
  circuit;
  reverseImplementation = ReverseImplementation;

  @computed('circuit', 'nominalValues', 'reverseImplementation', 'gbwArray') get circuits() {
    var circuit = this.circuit;
    var nominalGbw = circuit.opAmp.gbw;
    var nominalValues = this.nominalValues;
    var reverseImplementation = this.reverseImplementation;
    var c1ToleranceArray = circuit.c1.toleranceArray;
    var r1ToleranceArray = circuit.r1.toleranceArray;
    var r3ToleranceArray = circuit.r3.toleranceArray;
    var r4ToleranceArray = circuit.r4.toleranceArray;
    var inverseArray = circuit.r3.value ? r3ToleranceArray : r4ToleranceArray;

    var r4Start = r3ToleranceArray.length - 1;
    var gbwArray = this.gbwArray;
    var bigHugeCircuitArray = [];
    gbwArray.forEach((gbwValue) => {
      r1ToleranceArray.forEach((r1Value) => {
        inverseArray.forEach((inverseValue, index) => {
          var r3Value = r3ToleranceArray[index];
          var r4Value = r4ToleranceArray[r4Start - index];
          c1ToleranceArray.forEach((c1Value) => {
            let item = BigHugeCircuit.create({
              c1: c1Value,
              r1: r1Value,
              r3: r3Value,
              r4: r4Value,
              opAmpGbw: gbwValue,
              nominalValues: nominalValues,
              nominalGbw: nominalGbw,
              reverseImplementation: reverseImplementation,
            });
            bigHugeCircuitArray.push(item);
          });
        });
      });
    });

    var result = this.setNormalizers(bigHugeCircuitArray);
    return result;
  }
}
